import React from "react";
import { FaPeopleGroup } from "react-icons/fa6";
import { FaCarAlt } from "react-icons/fa";
import { MdTimer } from "react-icons/md";

const ServiceCard = ({ service }) => {
  return (
    <div className='border-[1px] shadow-sm rounded-md flex flex-col'>
      <img src={service.image} alt={service.name} className='h-[280px]' />
      <h2 className=' font-bold text-center p-4 text-3xl text-gray-700'>
        {service.name}
      </h2>
      <p className='p-6 text-justify text-[13px] font-thin'>
        {service.description}
      </p>
      <span className='text-center  text-xl font-bold w-full bg-gray-500 text-white flex items-center justify-between p-4'>
        <span className='flex items-center justify-center gap-3'>
          <FaPeopleGroup color='#ff4d30' size={23} /> {service.passengers}
        </span>
        <span className='flex items-center justify-center gap-3'>
          <FaCarAlt color='#ff4d30' size={23} /> {service.bags}
        </span>
      </span>
      <div className='flex flex-col items-center justify-center p-4'>
        <MdTimer color='#ff4d30' size={28} />
        <span className='text-2xl font-bold'>{service.duration}</span>
      </div>
      <div className='flex items-center justify-between gap-4 p-4'>
        <button className='text-white bg-[#ff4d30] py-3 px-10 border-[1px] text-[15px] rounded-md'>
          Details
        </button>
        <button className='text-white bg-[#ff4d30] py-3 px-6 border-[1px] text-[15px] rounded-md'>
          Whatsapp
        </button>
      </div>
    </div>
  );
};

export default ServiceCard;
